import React from 'react';
import StyledToolTip from '../../../../../../../common/StyledToolTip';

const RendererIcon = ({ title, icon }) => (
  <StyledToolTip title={title}>
    <div>{icon}</div>
  </StyledToolTip>
);

const PickupIndicatorIconRenderer = ({ data }) => {
  return data.isMergedPickup ? (
    <RendererIcon
      title={`Merged to ${data.pickupMergedTo}`}
      icon={<i className="icon-merge-routes" />}
    />
  ) : null;
};

export default PickupIndicatorIconRenderer;
